import React, { useState, useEffect } from "react";
import SkeletonCardBerita from "./skeleton/CardBerita";
import BeritaCard from "./BeritaCard";
import axios from "axios";
import Swal from "sweetalert2";
import dayjs from 'dayjs';
import 'dayjs/locale/id';
import 'dayjs/locale/en';
import { useCookies } from 'react-cookie';

import Col from 'react-bootstrap/Col';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import Row from 'react-bootstrap/Row';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
const BeritaTerkini = () => {

    const { t } = useTranslation()
    const [cookies] = useCookies(['i18next']);
    const formatDate = (date, locale = 'en') => {
        dayjs.locale(locale); // Set the locale dynamically
        return dayjs(date).format('DD MMMM YYYY'); // Format the date
    };
    const [loading, setLoading] = useState(true);
    const [posts, setPosts] = useState([]);
    const [filteredPosts, setFilteredPosts] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const postsPerPage = 9;
    const [startDate, setStartDate] = useState("");
    const [searchTitle, setSearchTitle] = useState("");
    const convertToSlug = (title) => {
        if (!title) return ""; // Handle null or undefined title
        return title
            .toLowerCase()
            .trim()
            .replace(/[^\w\s-]/g, "")
            .replace(/\s+/g, "-")
            .replace(/-+/g, "-");
    };

    useEffect(() => {
        const fetchPosts = async () => {
            setLoading(true);
            try {
                const lang = cookies.i18next || 'id'; // Ambil bahasa aktif
                // Tambahkan parameter bahasa ke URL (Misal: ?lang=en). 
                // Tanyakan kepada tim Backend format parameter apa yang mereka gunakan.
                const url = process.env.REACT_APP_API_URL + `/news_category/cat/1?lang=${lang}`;

                const response = await axios.get(url);
                setPosts(response.data);
                setFilteredPosts(response.data);
            } catch (err) {
                // ... handle error
            } finally {
                setLoading(false);
            }
        };

        fetchPosts();
    }, [cookies.i18next]); // <-- Tambahkan cookies.i18next agar API dipanggil ulang saat bahasa berubah

    useEffect(() => {
        let filtered = posts;

        // ✅ Filter berdasarkan tanggal jika ada input
        if (startDate) {
            const formattedDate = dayjs(startDate).format("YYYY-MM-DD");
            filtered = filtered.filter(
                (post) => dayjs(post.news_datetime).format("YYYY-MM-DD") === formattedDate
            );
        }

        // ✅ Filter berdasarkan judul jika ada input
        if (searchTitle) {
            filtered = filtered.filter((post) => {
                // Cek bahasa aktif, lalu tentukan judul mana yang akan dicari
                const titleToSearch = cookies.i18next === 'en' && post.title_en
                    ? post.title_en
                    : post.title;

                // Tambahkan fallback string kosong jika titleToSearch undefined
                return (titleToSearch || "").toLowerCase().includes(searchTitle.toLowerCase());
            });
        }

        setFilteredPosts(filtered);
        setCurrentPage(1); // Reset ke halaman pertama setelah filter berubah
    }, [searchTitle, startDate, posts]);
    const lastPostIndex = currentPage * postsPerPage;
    const firstPostIndex = lastPostIndex - postsPerPage;
    const currentPosts = filteredPosts.slice(firstPostIndex, lastPostIndex);

    const totalPages = Math.ceil(filteredPosts.length / postsPerPage);

    const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

    const generatePaginationItems = () => {
        if (totalPages <= 5) {
            return Array.from({ length: totalPages }, (_, i) => i + 1);
        }
        if (currentPage <= 2) {
            return [1, 2, 3, '...', totalPages];
        }
        if (currentPage >= totalPages - 1) {
            return [1, '...', totalPages - 2, totalPages - 1, totalPages];
        }
        return [1, '...', currentPage, '...', totalPages];
    };


    const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
        <FormControl
            value={value}
            onClick={onClick}
            ref={ref}
            placeholder={cookies.i18next === 'id' ? 'Filter Tanggal' : 'Filter Date'}
            readOnly // Makes the input read-only
            size="sm"
            style={{ paddingTop: '8px', paddingBottom: '9px', border: '1px solid #ccc' }}
        />
    ));

    return (
        <>
            <div className='page-wrapper'>
                <section className='page-banner'>
                    <div className='container'>
                        <div className='page-banner-title'>
                            <h3>{t('menu.beritaTerkini')}</h3>
                        </div>
                    </div>
                </section>
                <section className='berita-section'>
                    <div className='container'>
                        <Row className="pb-3" >
                            <Col md={7} className="pb-3 offset-md-2">
                                <InputGroup >

                                    <input
                                        type="text"
                                        placeholder={cookies.i18next === 'id' ? 'Filter Judul' : 'Filter Title'}
                                        value={searchTitle}
                                        className="form-control form-control-sm"
                                        onChange={(e) => setSearchTitle(e.target.value)}
                                        style={{ paddingTop: '8px', paddingBottom: '9px', border: '1px solid #ccc' }}
                                    />
                                    <InputGroup.Text><i className="fa fa-search" style={{ color: "#00a651" }}></i></InputGroup.Text>
                                </InputGroup>
                            </Col>

                            <Col md={3} className="" >
                                <InputGroup className="d-flex justify-content-end">
                                    <DatePicker
                                        dateFormat="dd-MM-yyyy"
                                        onChange={(date) => setStartDate(date)}
                                        selected={startDate}
                                        // placeholderText="Pilih tanggal"
                                        //   className="form-control"
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        isClearable={!!startDate}
                                        customInput={<CustomInput />}
                                        className="w-100"

                                    />
                                    <InputGroup.Text><i className="fa fa-calendar text-muted"></i></InputGroup.Text>
                                </InputGroup>
                            </Col>
                        </Row>
                        <div className='row row-gutter-30'>
                            {loading
                                ? Array(postsPerPage)
                                    .fill()
                                    .map((_, index) => (
                                        <div
                                            className='col-lg-4 col-md-6'
                                            key={index}>
                                            <SkeletonCardBerita />
                                        </div>
                                    ))
                                :
                                currentPosts.length > 0 ? (
                                    currentPosts.map((item) => {
                                        // Tentukan judul berdasarkan bahasa aktif untuk dijadikan slug URL
                                        const slugTitle = cookies.i18next === 'en' && item.title_en ? item.title_en : item.title;

                                        return (
                                            <div className='col-lg-4 col-md-6' key={item.id}>
                                                <BeritaCard
                                                    item={item}
                                                    href={`/berita-terkini/${item.id}/${convertToSlug(slugTitle)}`}
                                                />
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div className="col-lg-12 col-md-12" style={{ marginBottom: '200px' }}>
                                        <p className="text-center">No posts available</p>
                                    </div>
                                )}

                            {!loading && totalPages > 1 && (
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    gap: '10px',
                                    marginTop: '25px',
                                    flexWrap: 'wrap',
                                }}>
                                    {/* Tombol Prev */}
                                    <div
                                        onClick={() => currentPage > 1 && handlePageChange(currentPage - 1)}
                                        style={{
                                            width: '38px', height: '38px',
                                            borderRadius: '50%',
                                            border: '2px solid #e0e0e0',
                                            background: '#ffffff',
                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                            cursor: currentPage === 1 ? 'default' : 'pointer',
                                            opacity: currentPage === 1 ? 0.4 : 1,
                                            color: '#6c757d', fontSize: '0.9rem', flexShrink: 0,
                                        }}
                                    >
                                        <i className="fa-solid fa-chevron-left"></i>
                                    </div>

                                    {/* Nomor halaman */}
                                    {generatePaginationItems().map((page, index) =>
                                        page === '...' ? (
                                            <span key={`ellipsis-${index}`} style={{ color: '#6c757d', fontSize: '14px', padding: '0 4px' }}>...</span>
                                        ) : (
                                            <div
                                                key={index}
                                                onClick={() => handlePageChange(page)}
                                                style={{
                                                    width: '36px', height: '36px',
                                                    borderRadius: '8px',
                                                    border: 'none',
                                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                    cursor: 'pointer',
                                                    fontSize: '0.9rem', fontWeight: '600', flexShrink: 0,
                                                    background: currentPage === page ? '#00994B' : '#f1f3f5',
                                                    color: currentPage === page ? '#ffffff' : '#6c757d',
                                                    boxShadow: currentPage === page ? '0 3px 10px rgba(0,153,75,0.35)' : 'none',
                                                }}
                                            >
                                                {page}
                                            </div>
                                        )
                                    )}

                                    {/* Tombol Next */}
                                    <div
                                        onClick={() => currentPage < totalPages && handlePageChange(currentPage + 1)}
                                        style={{
                                            width: '38px', height: '38px',
                                            borderRadius: '50%',
                                            border: '2px solid #e0e0e0',
                                            background: '#ffffff',
                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                            cursor: currentPage === totalPages ? 'default' : 'pointer',
                                            opacity: currentPage === totalPages ? 0.4 : 1,
                                            color: '#6c757d', fontSize: '0.9rem', flexShrink: 0,
                                        }}
                                    >
                                        <i className="fa-solid fa-chevron-right"></i>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default BeritaTerkini;
